module.exports = __webpack_public_path__ + "dist/img/group.2e79a675.jpg";